import React, {Component} from 'react'
import {FormattedMessage} from "react-intl";
import {AppContext} from "@lightspeed-invoicing/core-client/frontend";
import Icon from "../common/icon/icon.component.jsx";
import UAParser from "ua-parser-js"
import {  Map, TileLayer, Marker, Popup } from 'react-leaflet'

class FingerprintDetails extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            fingerprint: this.props.fingerprint || null,
            fingerprintId: this.props.fingerprintId || '',
            className: this.props.className || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        let reload = this.loadFingerprint
        let fingerprint = nextProps.fingerprint
        if (nextProps.fingerprintId === this.state.fingerprintId) {
            reload = () => {}
            fingerprint = this.state.fingerprint
        }
        this.setState({
            fingerprint: fingerprint,
            fingerprintId: nextProps.fingerprintId || null,
            className: nextProps.className || '',
        }, reload)
    }

    componentDidMount() {
        this.loadFingerprint()
    }

    loadFingerprint() {
        if (this.state.fingerprintId) {
            AppContext.getApiClient().get('/fingerprints/' + this.state.fingerprintId).then(res => {
                this.setState({fingerprint: res})
            })
        }
    }

    render() {
        if (!this.state.fingerprint) {
            return <div />
        }
        const parser = new UAParser()
        parser.setUA(this.state.fingerprint.attributes.userAgent)
        const userAgent = parser.getResult()
        const position = [this.state.fingerprint.attributes.cityLatitude, this.state.fingerprint.attributes.cityLongitude]
        return  <div className={'w-100 d-flex align-items-top flex-wrap align-self-stretch'}>
            <div className={this.props.style !== 'panel' ? 'w-100 w-md-25 pt-3' : 'w-50 pt-3'}>
                <Map center={position} zoom={10} style={{minHeight: '125px', height:'100%'}} zoomControl={false} scrollWheelZoom={false}>
                    <TileLayer
                        url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
                    />
                    <Marker position={position}>
                        <Popup>
                            {this.state.fingerprint.attributes.city.toUpperCase()}, {this.state.fingerprint.attributes.regionCode.toUpperCase()}, {this.state.fingerprint.attributes.countryCode}
                        </Popup>
                    </Marker>
                </Map>
            </div>
            <div className={this.props.style !== 'panel' ? 'px-0 px-md-3 pt-3' : 'w-50 pt-3'}>
                <div className={'bg-light'}>
                    <div className={'w-100 mb-2 border-bottom py-2 px-3'}>
                        <strong>
                            <FormattedMessage
                                id="fingerprint.device_information_label"
                                defaultMessage="Device information"
                            />
                        </strong>
                    </div>
                    <div className={'w-100 d-flex px-3 py-2'}>
                        {this.props.style !== 'panel' && <div className={'pr-3'} style={{fontSize: '3em'}}>
                            <Icon value={'fingerprint'}/>
                        </div>}
                        <div className={'flex-grow-1'}>
                            <div className={'w-100'}>
                                <samp>{this.state.fingerprint.attributes.ip}</samp>
                            </div>
                            <div className={'w-100'}>
                                <samp>{this.state.fingerprint.attributes.city.toUpperCase()}, {this.state.fingerprint.attributes.regionCode.toUpperCase()}, {this.state.fingerprint.attributes.countryCode}</samp>
                            </div>
                            <div className={'w-100'}>
                                <small>
                                    <samp>{userAgent.os.name} {userAgent.os.version} / {userAgent.browser.name} {userAgent.browser.version}</samp>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    }

}

export default FingerprintDetails





// WEBPACK FOOTER //
// ./src/fingerprint/details.component.jsx